import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, useTheme } from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutlined, Edit, FilterList, Info } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import "moment/locale/id";
import FloatingAlert from "components/FloatingAlert";
import {
  resetDetailSetoranHarian,
  resetPengeluaranSetoran,
  setMessage,
  setStatus,
} from "state";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import {
  fetchChangeStatusSetoran,
  fetchDeleteSetoran,
  fetchEditCatatanSetoran,
  fetchListSetoran,
  fetchDetailSetoranPerhari,
  fetchPengeluaranSetoran,
  fetchGetPengeluaranSetoran,
  fetchGetPengeluaranSetoranGlobal,
  fetchSaveWarkat,
} from "state/setoranAction";
import formatRupiah from "utils/formatRupiah";
import DetailSetoranModal from "components/Modals/DetailSetoranModal";
import EditCatatanModal from "components/Modals/EditCatatanModal";
import DetailSetoranHarianModal from "components/Modals/DetailSetoranHarianModal";
import CustomFilterModal from "./CustomFilterModal";
import SortableHeader from "components/SortableHeader";
import DetailSetoranModalTransfer from "components/Modals/DetailSetoranModalTransfer";
moment.locale("id");

const Setoran = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { status, message } = useSelector((state) => state.global);
  const {
    list_setoran,
    detail_setoran_harian,
    pengeluaran_setoran,
    pengeluaran_setoran_global,
  } = useSelector((state) => state.setoran);
  console.log("detail_setoran_harian", detail_setoran_harian);

  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openDetailTransfer, setOpenDetailTransfer] = useState(false);
  const [openEditCatatan, setOpenEditCatatan] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [showingDetail, setShowingDetail] = useState(false);

  const [filteredData, setFilteredData] = React.useState([]);
  const [appliedFilters, setAppliedFilters] = React.useState({});
  const [openCustomFilter, setOpenCustomFilter] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  useEffect(() => {
    dispatch(fetchListSetoran());
  }, []);

  useEffect(() => {
    // Apply filters whenever data or filters change
    if (list_setoran) {
      const filtered = applyCustomFilters(list_setoran, appliedFilters);
      setFilteredData(filtered);
    }
  }, [list_setoran, appliedFilters]);
  const handleApplyCustomFilter = (filters) => {
    setAppliedFilters(filters);
  };

  // Main filter logic
  const applyCustomFilters = (data, filterConfig) => {
    if (!filterConfig || Object.keys(filterConfig).length === 0) return data;

    let result = [...data];

    if (filterConfig.dateRange) {
      const { tanggalAwal, tanggalAkhir } = filterConfig.dateRange;

      if (tanggalAwal || tanggalAkhir) {
        const startBoundary = tanggalAwal
          ? moment(tanggalAwal).startOf("day")
          : null;

        const endBoundary = tanggalAkhir
          ? moment(tanggalAkhir).endOf("day")
          : null;

        result = result.filter((row) => {
          if (!row.waktu_setoran) return false;

          const rowDate = moment(row.waktu_setoran, "YYYY-MM-DD");

          if (!rowDate.isValid()) {
            console.warn(
              `Invalid date format found for row: ${row.waktu_setoran}`,
            );
            return false;
          }

          const isAfterStart = startBoundary
            ? rowDate.isSameOrAfter(startBoundary)
            : true;

          const isBeforeEnd = endBoundary
            ? rowDate.isSameOrBefore(endBoundary)
            : true;

          return isAfterStart && isBeforeEnd;
        });
      }
    }

    if (filterConfig.filter) {
      if (
        filterConfig.filter.nama_cab &&
        filterConfig.filter.nama_cab.length > 0
      ) {
        result = result.filter((row) => {
          return filterConfig.filter.nama_cab.includes(row.nama_cab);
        });
      }

      if (
        filterConfig.filter.nama_karyawan &&
        filterConfig.filter.nama_karyawan.length > 0
      ) {
        result = result.filter((row) => {
          return filterConfig.filter.nama_karyawan.includes(row.nama_karyawan);
        });
      }

      if (filterConfig.filter.status) {
        const statusFilterValue = filterConfig.filter.status;

        result = result.filter((row) => {
          return row.status === statusFilterValue;
        });
      }
    }

    // Apply Sort
    if (filterConfig.sort && filterConfig.sort.length > 0) {
      result.sort((a, b) => {
        for (let sortRule of filterConfig.sort) {
          let { column, order } = sortRule;
          let aValue = a[column];
          let bValue = b[column];

          if (aValue == null) return 1;
          if (bValue == null) return -1;

          if (typeof aValue === "string") aValue = aValue.toLowerCase();
          if (typeof bValue === "string") bValue = bValue.toLowerCase();

          if (aValue < bValue) return order === "asc" ? -1 : 1;
          if (aValue > bValue) return order === "asc" ? 1 : -1;
        }
        return 0;
      });
    }

    return result;
  };

  const handleClearCustomFilter = () => {
    setAppliedFilters({});
    setFilteredData([]);
  };
  // Count active filters
  const getActiveFilterCount = () => {
    let count = 0;

    if (appliedFilters.dateRange) {
      if (
        appliedFilters.dateRange.tanggalAwal ||
        appliedFilters.dateRange.tanggalAkhir
      ) {
        count++;
      }
    }

    if (appliedFilters.filter) {
      if (appliedFilters.filter.nama_cab?.length > 0) count++;
      if (appliedFilters.filter.nama_karyawan?.length > 0) count++;
      if (appliedFilters.filter.status?.length > 0) count++;
    }

    // ✅ Sort (multiple)

    return count;
  };

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListSetoran());
    setIsDelete(false);
  };

  const handleSelectedData = (id) => {
    let currentSelectedData = list_setoran.find((item) => item.id === id);
    setSelectedData(currentSelectedData);
    dispatch(fetchGetPengeluaranSetoran(currentSelectedData));
  };
  const handleSetujui = () => {
    dispatch(fetchChangeStatusSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const handleDelete = () => {
    dispatch(fetchDeleteSetoran(selectedData.id));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };
  const handleSubmitEditKaryawan = (value) => {
    dispatch(fetchEditCatatanSetoran(selectedData.id, value));
    setOpenEditCatatan(false);
    setSelectedData(null);
  };

  const handleSaveWarkat = (value) => {
    dispatch(fetchSaveWarkat(value));
    setOpenDetail(false);
    setSelectedData(null);
  };

  const handleSubmitPengeluaran = (value, justApprove) => {
    if (!!justApprove) {
      handleSetujui();
    } else {
      if (!value.id) {
        handleSetujui();
      }
      dispatch(fetchPengeluaranSetoran(value));
    }
    setOpenDetail(false);
  };
  const renderStatusSetoran = (value) => {
    if (value == "disetujui") {
      return "Disetujui";
    } else {
      return "Belum Disetujui";
    }
  };

  const columnsSetoran = [
    {
      name: "id", // Kolom UUID
      label: "ID",
      options: {
        display: false, // Disembunyikan dari tampilan tabel
      },
    },
    {
      name: "nama_cab",
      label: "Setoran Toko",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "tgl_kas",
      label: "Waktu Sinkron",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const waktuSetoran = tableMeta.rowData[3]; // Ambil ID dari kolom pertama
          return (
            <a
              style={{ cursor: "pointer", color: "red" }}
              onClick={(e) => {
                e.preventDefault(); // karena pakai <a>, hindari reload
                dispatch(fetchDetailSetoranPerhari(value, waktuSetoran));
                dispatch(fetchGetPengeluaranSetoranGlobal(value));
                setShowingDetail(true);
              }}
            >
              {value === "-" ? "-" : moment(value).format("DD/MM/YYYY")}
            </a>
          );
        },
      },
    },
    {
      name: "waktu_setoran",
      label: "Waktu Setoran",
      options: {
        filter: true,
        sort: true,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const tglKas = tableMeta.rowData[2]; // Ambil ID dari kolom pertama
          return (
            <a
              style={{ cursor: "pointer", color: "red" }}
              onClick={(e) => {
                e.preventDefault(); // karena pakai <a>, hindari reload
                dispatch(fetchDetailSetoranPerhari(tglKas, value));
                dispatch(fetchGetPengeluaranSetoranGlobal(tglKas));
                setShowingDetail(true);
              }}
            >
              {value === "-" ? "-" : moment(value).format("DD/MM/YYYY")}
            </a>
          );
        },
      },
    },
    {
      name: "nominal_setoran",
      label: "Nominal Setoran",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => formatRupiah(value),
      },
    },
    {
      name: "nama_karyawan",
      label: "Nama Penyetor",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
      },
    },
    {
      name: "status",
      label: "Status Setoran",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => renderStatusSetoran(value),
      },
    },
    {
      name: "transfer", // Kolom UUID
      label: "Transfer",
      options: {
        display: false, // Disembunyikan dari tampilan tabel
      },
    },
    {
      name: "tipe",
      label: "Tipe Setoran",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),

        customBodyRender: (value, tableMeta, updateValue) => {
          const transfer = tableMeta.rowData[7];
          if (transfer > 0) {
            return "Transfer";
          } else {
            return "Tunai";
          }
        },
      },
    },
    {
      name: "catatan",
      label: "Catatan Setoran",
      options: {
        filter: true,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (columnMeta, handleToggleColumn, sortOrder) => (
          <SortableHeader
            key={`col-${columnMeta.index}`}
            label={columnMeta.label}
            columnName={columnMeta.name}
            sortOrder={sortOrder}
            onClick={() => handleToggleColumn(columnMeta.index)}
            sorting
          />
        ),
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0]; // Ambil ID dari kolom pertama
          const transfer = tableMeta.rowData[7];
          return (
            <>
              <IconButton
                color="info"
                onClick={() => {
                  handleSelectedData(id);
                  if (transfer > 0) {
                    setOpenDetailTransfer(true);
                  } else {
                    setOpenDetail(true);
                  }
                }}
              >
                <Info />
              </IconButton>
              <IconButton
                color="info"
                onClick={() => {
                  handleSelectedData(id);
                  setOpenEditCatatan(true);
                }}
              >
                <Edit />
              </IconButton>
              <IconButton
                color="warning"
                onClick={() => {
                  handleSelectedData(id);
                  setIsDelete(true);
                  setOpenKonfirmasi(true);
                }}
              >
                <DeleteOutlined />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    filter: false,
    fixedHeader: false,
    fixedSelectColumn: false,
    search: true,
    viewColumns: false,
    responsive: "standard",
    customToolbar: () => {
      const activeCount = getActiveFilterCount();
      return (
        <Button
          startIcon={<FilterList />}
          onClick={() => setOpenCustomFilter(true)}
          variant={activeCount > 0 ? "contained" : "outlined"}
          size="small"
          color={activeCount > 0 ? "primary" : "inherit"}
          sx={{
            mr: 1,
            ...(activeCount === 0 && {
              color: "text.secondary",
              borderColor: "text.secondary",
            }),
          }}
        >
          Filter {activeCount > 0 && `(${activeCount})`}
        </Button>
      );
    },
    rowsPerPageOptions: [
      30,
      60,
      filteredData.length > 0 || Object.keys(appliedFilters).length > 0
        ? filteredData.length
        : list_setoran.length,
    ],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="Setoran" subtitle="Daftar Setoran dari setiap toko." />

      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={
            filteredData.length > 0 || Object.keys(appliedFilters).length > 0
              ? filteredData
              : list_setoran
          }
          columns={columnsSetoran}
          options={options}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={isDelete ? "Hapus" : "Setujui"}
          subtitleType={isDelete ? "Menghapus" : "Menyetujui"}
          dataWillProses={"Setoran Ini"}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => (isDelete ? handleDelete() : handleSetujui())}
          textButtonPositif={isDelete ? "Hapus" : "Setujui"}
        />
        <EditCatatanModal
          open={openEditCatatan}
          dataEdit={selectedData}
          onClose={() => setOpenEditCatatan(false)}
          onSubmit={(value) => handleSubmitEditKaryawan(value)}
        />
        <DetailSetoranModal
          dataDetail={selectedData}
          dataPengeluaran={pengeluaran_setoran}
          open={openDetail}
          onClose={() => {
            setSelectedData(null);
            setOpenDetail(false);
          }}
          onSubmit={handleSubmitPengeluaran}
        />

        <DetailSetoranModalTransfer
          dataDetail={selectedData}
          dataPengeluaran={pengeluaran_setoran}
          open={openDetailTransfer}
          onClose={() => {
            setSelectedData(null);
            setOpenDetailTransfer(false);
          }}
          onSubmit={handleSubmitPengeluaran}
        />

        <DetailSetoranHarianModal
          dataDetail={detail_setoran_harian}
          dataPengeluaran={pengeluaran_setoran_global}
          open={showingDetail && detail_setoran_harian}
          onClose={() => {
            dispatch(resetDetailSetoranHarian());
            dispatch(resetPengeluaranSetoran());
            setShowingDetail(false);
          }}
          onSaveWarkat={handleSaveWarkat}
        />
        <CustomFilterModal
          open={openCustomFilter}
          onClose={() => setOpenCustomFilter(false)}
          onApplyFilter={handleApplyCustomFilter}
          onClearFilter={handleClearCustomFilter}
          data={list_setoran}
        />
      </Box>
    </Box>
  );
};

export default Setoran;
